"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContactPickerPane_1 = require("./components/ContactPickerPane");
exports.ContactPickerPane = ContactPickerPane_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-contact-picker/lib/lazyIndex.js
// module id = 3751
// module chunks = 99